// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3ZUmG","list":"BalanceDue_list__VUxZt","listRow":"BalanceDue_listRow__QI3Xd","total":"BalanceDue_total__2IU_p"};